import PropTypes from 'prop-types';
import React from 'react';
import styled, { withTheme } from 'styled-components';

import { Spinner } from './Boneyard';

const propTypes = {
  /** injects the generated stylesheet */
  className: PropTypes.string,
  automationHook: PropTypes.string,
};

const SpinnerOverlay = ({ className, automationHook }) => {
  return (
    <div className={className}>
      <Spinner size="small" automationHook={automationHook} />
    </div>
  );
};

SpinnerOverlay.propTypes = propTypes;

export default withTheme(styled(SpinnerOverlay)`
  background-color: rgba(255, 255, 255, 0.9);
  animation: fadein 0.33s;
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${props => props.theme.zIndex.spinnerOverlay};
`);
